import { DeepZoomAreaContext } from '../../DeepZoomArea';
import { useContext } from 'react';

export default function useDeepZoomArea() {
  const context = useContext(DeepZoomAreaContext);
  return context;
}
